module.exports = __webpack_public_path__ + "img/industry-banner-04.5ef2f9df.png";